import { z } from "zod";

export const answerContentSchema = z.object({
  id: z.number(),
  content: z.string(),
  answer: z.number(),
  extension_note: z.string().nullable(),
});

export const answerContentUpdateSchema = answerContentSchema.omit({
  content: true,
});

export type AnswerContent = z.infer<typeof answerContentSchema>;
export type AnswerContentUpdate = z.infer<typeof answerContentUpdateSchema>;
